class ForgotPasswordController {
  /* @ngInject */
  constructor ($mdDialog) {
    this.$mdDialog = $mdDialog
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  hide () {
    this.$mdDialog.hide(this.username)
  }
}

export default ForgotPasswordController
